import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';
import { HttpClient } from '@angular/common/http';
import { Observable, lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlanparcelDataService {

  private api;
  private configs;
  constructor(
    private httpClient: HttpClient,
    private config: AppConfigService
    ) { 
      this.loadConfigs();
    }

  async loadConfigs(){
    this.configs = await lastValueFrom(this.config.getJSON());
    this.api = this.configs.apiurl+'PlanParcel/';
  }

  saveParcelBounds(parcelData): Observable<any>{
    //await this.loadConfigs();
    // this.config.getJSON().subscribe((data)=>{
    //   this.api = data.apiurl;
    //   this.configs = data;
    // })
    return this.httpClient.post(this.api+'UpdateParcelsBounds',parcelData);
  }

  saveParcelDash(parcelData): Observable<any>{
    return this.httpClient.post(this.api+'UpdateParcelDash',parcelData);
  }
  
  savePlanDash(parcelData): Observable<any>{
    return this.httpClient.post(this.api+'UpdatePlanDash',parcelData);
  }

}
